import PropTypes from 'prop-types';

function MMPlantBasedActive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path
                d="M6.97389 26.197C6.97389 26.197 -0.214788 6.50293 24.4694 3.25244C24.4694 3.25244 28.8303 24.7588 12.548 26.197C11.1598 26.3218 6.97389 26.197 6.97389 26.197Z"
                fill="#4B874B"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11 21.2524C11 21.2524 13.4732 12.9527 20 8.25244"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11 21.2524C11 21.2524 12.5222 17.6745 19 16.2524"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default MMPlantBasedActive;

MMPlantBasedActive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.number.isRequired,
};

MMPlantBasedActive.defaultProps = {
    className: null,
};
